
   /**
    * 根据hash值处理sourceid
    * @param {Sring} hash - 页面hash 
    */
export function sourceIdHandler (hash) {
    let arrHash = (hash||location.hash).replace(/^#?\//,'').replace(/\?(.)*/,'').split('/')
    for (let i = 0; i < 5; i++) {
        if (arrHash.length < i) {
            arrHash.push('0')
        }
        if (i == 4){
            arrHash[i] = 'page'
        } else if (i == 0 && !arrHash[i]) {
            arrHash[i] = 'index'
        }
    }
    let sourceid = arrHash.join('.')
    return sourceid
}

/**
 * 标题特殊编码处理
 * @param {*} title 详情页标题
 * @param {*} targetid 详情页唯一标识
 */
export function titleHandler (title, targetid) {
    // 批量 & 单个判断
    if (String(targetid).indexOf(',') !== -1) {
        // 批量
        title = title.replace(/\|/g, '-')
    } else {
        // 单个
        title = title.replace(/\|/g, '-').replace(/\,/g, '，')
    }
    return title
}